import { render, staticRenderFns } from "./PassportApplicationList.vue?vue&type=template&id=683e5a68"
import script from "./PassportApplicationList.vue?vue&type=script&lang=js"
export * from "./PassportApplicationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports